import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import {TruckJourneyAssignmentLoad, TruckJourneyDetail} from '../../../models/truck-journey.model';
import { TruckJourneyLoadAssignmentComponent } from '../content/truck-journey-load-assignment.component';

@Component({
  selector: 'app-truck-journey-load-assignment-overlay',
  styleUrls: ['./truck-journey-load-assignment-overlay.component.scss'],
  templateUrl: './truck-journey-load-assignment-overlay.component.html'
})
export class TruckJourneyLoadAssignmentOverlayComponent implements OnChanges {

  @Input() truckJourneyLabel: string;
  @Input() isShowing: boolean;
  @Input() selectedLoads: TruckJourneyAssignmentLoad[];
  @Input() truckJourney: TruckJourneyDetail;

  @Output() isShowingChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() selectedLoadsChange: EventEmitter<TruckJourneyAssignmentLoad[]> = new EventEmitter<TruckJourneyAssignmentLoad[]>();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('loadAssignment', {static: true}) private loadAssignmentComponent: TruckJourneyLoadAssignmentComponent;

  newLoadsSelection: TruckJourneyAssignmentLoad[];

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedLoads) {
      this.newLoadsSelection = [...this.selectedLoads];
    }
  }

  public assignLoads(): void {
    this.selectedLoads = [...this.newLoadsSelection];
    this.newLoadsSelection = [];
    this.selectedLoadsChange.emit(this.selectedLoads);
    this.closeLoadAssignment();
  }

  public cancelAndCloseLoadAssignment(): void {
    this.newLoadsSelection = [...this.selectedLoads];
    this.onCancel.emit();
    this.closeLoadAssignment();
  }

  private closeLoadAssignment(): void {
    this.loadAssignmentComponent.reinitializeSelectableLoads();
    this.isShowing = false;
    this.isShowingChange.emit(false);
  }
}
